
import {ref, SetupContext} from 'vue'
import  FileUpload from '../../../src/FileUpload.vue'
import type  { VueUploadItem } from '../../../src/FileUpload.vue'
export default {
  components: {
    FileUpload,
  },

  setup(props: unknown, context: SetupContext) {
    const upload = ref<InstanceType<typeof FileUpload> | null>(null)
    
    const files = ref([])

    function inputFilter(newFile: VueUploadItem | undefined, oldFile: VueUploadItem | undefined, prevent: (prevent?: boolean) => boolean) {
      if (newFile && !oldFile) {
        // Before adding a file
        // 添加文件前

        // Filter system files or hide files
        // 过滤系统文件 和隐藏文件
    
        if (newFile.name && /(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent()
        }
        
        // Filter php html js file
        // 过滤 php html js 文件
        if (newFile.name && /\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent()
        }
      }
    }

    function inputFile(newFile: VueUploadItem | undefined, oldFile: VueUploadItem | undefined) {
      if (newFile && !oldFile) {
        // add
        console.log('add', newFile)
      }
      if (newFile && oldFile) {
        // update
        console.log('update', newFile)
      }

      if (!newFile && oldFile) {
        // remove
        console.log('remove', oldFile)
      }
    }

    return {
      files,
      upload,
      inputFilter,
      inputFile,
    }
  }
}
